import React, { useState, useEffect, useRef, useMemo } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import PhotoSizeSelectSmallIcon from "@mui/icons-material/PhotoSizeSelectSmall";
import { makeStyles } from "@mui/styles";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { useTranslation } from "react-i18next";
import { useNavigate,useLocation } from "react-router-dom";
import { Modal, Grid, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, FormControl } from "@mui/material";
import Button from "components/CustomButtons/Button.js";
import CancelIcon from "@mui/icons-material/Cancel";
import AlertDialog from "../components/AlertDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { colors } from "../components/Theme/WebTheme";
import { carTypeColumns, optionsRequired } from "common/sharedFunctions";
import { FONT_FAMILY, SECONDORY_COLOR } from "../common/sharedFunctions";
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import BlankTable from '../components/Table/BlankTable';
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';
import { getLangKey } from "common/src/other/getLangKey";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  submit3: {
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
  paper: {
    width: 700,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function CarTypes() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { editCarType, convertLanguage, fetchUsersOnce } = api;
  const [data, setData] = useState([]);
  const cartypes = useSelector((state) => state.cartypes);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState();
  const [modalType, setModalType] = useState();
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null)
  const auth = useSelector((state) => state.auth);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const zonelistdata = useSelector((state) => state.zonelistdata);
  const [fleetAdminsObj, setFleetAdminsObj] = useState({});
  const [zonesObj, setZonesObj] = useState({});
  const isFleetAdmin = auth?.profile?.usertype === "fleetadmin";

  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  const onClick = (rowData) => {
    setImageData(rowData.image);
    setProfileModal(true);
    setUserData(rowData);
  };

  function formatAmount(value, decimal, country) {
    const number = parseFloat(value || 0);
    if (country === "Vietnam") {
      return number.toLocaleString("vi-VN", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    } else {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    }
  }

  const columns = carTypeColumns(t, isRTL, onClick, formatAmount, settings);
  const extendedColumns = useMemo(() => {
    const extra = [
      {
        title: t("fleetadmins"),
        field: "fleetadmin",
        render: (rowData) => (rowData.fleetadmin ? (fleetAdminsObj[rowData.fleetadmin] || rowData.fleetadmin) : null),
      },
      {
        title: t("zone_name"),
        field: "zone_id",
        render: (rowData) => (rowData.zone_id ? (zonesObj[rowData.zone_id] || rowData.zone_id) : null),
      },
    ];
    return [...columns, ...extra];
  }, [columns, fleetAdminsObj, zonesObj, t]);
  const subcolumns = [
    {
      title: t("description"),
      field: "description",
      render: (rowData) => <span>{t(getLangKey(rowData.description))}</span>,
    },
    { title: t("amount"), field: "amount", type: "numeric" },
  ];

  const subcolumns2 = [
    {
      title: t("minsDelayed"),
      field: "minsDelayed",
      render: (rowData) => <span>{rowData.minsDelayed}</span>,
    },
    { title: t("amount"), field: "amount", type: "numeric" },
  ];

    const subcolumns3 = [
    {
      title: t("from_distance"),
      field: "from_distance",
      type: "numeric"
    },
    {
      title: t("to_distance"),
      field: "to_distance",
      type: "numeric"
    },
    { title: t("amount"), field: "amount", type: "numeric" },
  ];

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (cartypes.cars) {
      const all = cartypes.cars;
      setData(isFleetAdmin ? all.filter((c) => c.fleetadmin === auth?.profile?.uid) : all);
    } else {
      setData([]);
    }
  }, [cartypes.cars, isFleetAdmin, auth?.profile?.uid]);

  useEffect(() => {
    if (!staticusers) {
      dispatch(fetchUsersOnce());
    }
  }, [staticusers, dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      const admins = staticusers.filter((u) => u.usertype === "fleetadmin");
      const obj = {};
      for (let i = 0; i < admins.length; i++) {
        const u = admins[i];
        obj[u.id] = `${u.firstName || ""} ${u.lastName || ""}`.trim();
      }
      setFleetAdminsObj(obj);
    }
  }, [staticusers]);

  useEffect(() => {
    if (zonelistdata && zonelistdata.zones) {
      const obj = {};
      for (let i = 0; i < zonelistdata.zones.length; i++) {
        const z = zonelistdata.zones[i];
        obj[z.id] = z.zone_name;
      }
      setZonesObj(obj);
    }
  }, [zonelistdata]);

  const [selectedImage, setSelectedImage] = useState(null);
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  };

  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] = useState(false);
  const [imageData, setImageData] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [loading, setLoading] = useState(false);
  const [duplicateDialog, setDuplicateDialog] = useState({ open: false, sourceZoneId: null });
  const [selectedDuplicateZone, setSelectedDuplicateZone] = useState("");

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const groupCarTypesByZone = useMemo(() => {
    const grouped = {};
    data.forEach(carType => {
      const zoneId = carType.zone_id || "unassigned";
      const zoneName = zonesObj[zoneId] || (zoneId === "unassigned" ? "Unassigned" : zoneId);
      if (!grouped[zoneId]) {
        grouped[zoneId] = {
          zoneName,
          carTypes: [],
        };
      }
      grouped[zoneId].carTypes.push(carType);
    });
    return grouped;
  }, [data, zonesObj]);

  const handleDuplicateZoneGroup = (sourceZoneId) => {
    setDuplicateDialog({ open: true, sourceZoneId });
    setSelectedDuplicateZone("");
  };

  const getAvailableZonesForDuplicate = useMemo(() => {
    const zonesInUse = Object.keys(groupCarTypesByZone);
    return zonelistdata?.zones?.filter(zone => !zonesInUse.includes(zone.id)) || [];
  }, [groupCarTypesByZone, zonelistdata?.zones]);

  const handleConfirmDuplicate = async () => {
    if (!selectedDuplicateZone) {
      setCommonAlert({ open: true, msg: t("select_zone_first") });
      return;
    }
    
    const sourceGroup = groupCarTypesByZone[duplicateDialog.sourceZoneId];
    if (!sourceGroup || !sourceGroup.carTypes.length) return;

    if(settings.AllowCriticalEditsAdmin){
      // Duplicate all car types from source zone to target zone
      sourceGroup.carTypes.forEach(carType => {
        const { id, ...carTypeWithoutId } = carType;
        const duplicatedCarType = {
          ...carTypeWithoutId,
          zone_id: selectedDuplicateZone,
          fleetadmin: "", // Clear fleet admin as requested
        };
        dispatch(editCarType(duplicatedCarType, "Add"));
      });
      setDuplicateDialog({ open: false, sourceZoneId: null });
      setSelectedDuplicateZone("");
      setCommonAlert({ open: true, msg: t("group_duplicated") || "Zone group duplicated successfully" });
    } else {
      setCommonAlert({ open: true, msg: t('demo_mode') });
    }
  };

  const handleSetProfileModal = (e) => {
    e.preventDefault();
    if(settings.AllowCriticalEditsAdmin){
    if (selectedImage) {
      setLoading(true);
      let finalData = userData;
      finalData.image = selectedImage;
      dispatch(editCarType(finalData, "UpdateImage"));
      setProfileModal(false);
      setTimeout(() => {
        setSelectedImage(null);
        setLoading(false);
      }, 10000);
    } else {
      setCommonAlert({ open: true, msg: t("choose_image_first") });
    }
  }else{
    setLoading(false); 
    setCommonAlert({ open: true, msg: t('demo_mode') })
  }
  };

  const [selectedRow, setSelectedRow] = useState(null);
  return cartypes.loading ? (
    <CircularLoading />
  ) : (
    <div ref={rootRef}>
    <ThemeProvider theme={theme}>
      {data?.length > 0 ? (
        <div style={{ width: "100%" }}>
          {Object.keys(groupCarTypesByZone).map((zoneId) => {
            const group = groupCarTypesByZone[zoneId];
            return (
              <div key={zoneId} style={{ marginBottom: 30, display: "flex", flexDirection: "column", maxHeight: "55vh", overflow: "hidden" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 15 }}>
                  <Typography variant="h6" style={{ fontFamily: FONT_FAMILY, color: SECONDORY_COLOR, fontWeight: "bold" }}>
                    {t("zone")}: {group.zoneName}
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<FileCopyIcon />}
                    onClick={() => handleDuplicateZoneGroup(zoneId)}
                    style={{ color: SECONDORY_COLOR, borderColor: SECONDORY_COLOR }}
                  >
                    {t("duplicate_group") || "Duplicate Group"}
                  </Button>
                </div>
                <MaterialTable
                  title={`${t("car_type_title")} - ${group.zoneName}`}
                  columns={extendedColumns}
                  onChangePage={(page) => HandalePageChange(page)}
                  style={{
                    direction: isRTL === "rtl" ? "rtl" : "ltr",
                    borderRadius: "8px",
                    boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
                    flex: 1,
                    height: "100%",
                    overflow: "auto",
                  }}
                  data={group.carTypes}
                  onRowClick={(evt, selectedRow) =>
                    setSelectedRow(selectedRow.tableData.id)
                  }
                  options={{
                    initialPage: state?.pageNo,
                    exportButton: true,
                    rowStyle: (rowData) => ({
                      backgroundColor:
                        selectedRow === rowData.tableData.id ? colors.ROW_SELECTED : colors.WHITE
                    }),
                    ...TableStyle()
                  }}
                  localization={localization(t)}
                  editable={isFleetAdmin ? undefined : {
                    onRowDelete: (oldData) =>
                      settings.AllowCriticalEditsAdmin
                        ? new Promise((resolve) => {
                            setTimeout(() => {
                              resolve();
                              dispatch(editCarType(oldData, "Delete"));
                            }, 600);
                          })
                        : new Promise((resolve) => {
                            setTimeout(() => {
                              resolve();
                              alert(t("demo_mode"));
                            }, 600);
                          }),
                  }}
                  actions={
                    isFleetAdmin
                      ? [
                          (rowData) => ({
                            icon: () => (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexWrap: "wrap",
                                  width: "155px",
                                  maxWidth: "200px",
                                }}
                              >
                                <CancelScheduleSendIcon />
                                <Typography variant="subtitle2" style={{ padding: 5 }}>
                                  {t("cancelSlab")}
                                </Typography>
                              </div>
                            ),
                            onClick: (event, rowData) => {
                              setModalType("cancelSlab");
                              setRowIndex(data.indexOf(rowData));
                              setOpen(true);
                            },
                          }),
                          (rowData) => ({
                            icon: () => (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexWrap: "wrap",
                                  width: "155px",
                                  maxWidth: "200px",
                                }}
                              >
                                <FitnessCenterIcon />
                                <Typography variant="subtitle2" style={{ padding: 5 }}>
                                  {t("distanceSlab")}
                                </Typography>
                              </div>
                            ),
                            onClick: (event, rowData) => {
                              setModalType("distanceSlab");
                              setRowIndex(data.indexOf(rowData));
                              setOpen(true);
                            },
                          }),
                          {
                            icon: "edit",
                            tooltip: t("edit"),
                            onClick: (event, rowData) => {
                              navigate(`/cartypes/editcartype/${rowData.id}`, { state: { pageNo: currentPage } });
                            }
                          }
                        ]
                      : [
                          optionsRequired
                            ? (rowData) => ({
                                icon: () => (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                      width: "135px",
                                      maxWidth: "200px",
                                    }}
                                  >
                                    <PhotoSizeSelectSmallIcon />
                                    <Typography variant="subtitle2" style={{ padding: 5 }}>
                                      {t("parcel_types")}
                                    </Typography>
                                  </div>
                                ),
                                onClick: (event, rowData) => {
                                  setModalType("parcelTypes");
                                  setRowIndex(data.indexOf(rowData));
                                  setOpen(true);
                                }
                              })
                            : null,
                          optionsRequired
                            ? (rowData) => ({
                                icon: () => (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                      width: "95px",
                                      maxWidth: "150px",
                                    }}
                                  >
                                    <FitnessCenterIcon />
                                    <Typography variant="subtitle2" style={{ padding: 5 }}>
                                      {t("options")}
                                    </Typography>
                                  </div>
                                ),
                                onClick: (event, rowData) => {
                                  setModalType("options");
                                  setRowIndex(data.indexOf(rowData));
                                  setOpen(true);
                                }
                              })
                            : null,
                          (rowData) => ({
                            icon: () => (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexWrap: "wrap",
                                  width: "155px",
                                  maxWidth: "200px",
                                }}
                              >
                                <CancelScheduleSendIcon />
                                <Typography variant="subtitle2" style={{ padding: 5 }}>
                                  {t("cancelSlab")}
                                </Typography>
                              </div>
                            ),
                            onClick: (event, rowData) => {
                              setModalType("cancelSlab");
                              setRowIndex(data.indexOf(rowData));
                              setOpen(true);
                            }
                          }),
                          (rowData) => ({
                            icon: () => (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexWrap: "wrap",
                                  width: "155px",
                                  maxWidth: "200px",
                                }}
                              >
                                <FitnessCenterIcon />
                                <Typography variant="subtitle2" style={{ padding: 5 }}>
                                  {t("distanceSlab")}
                                </Typography>
                              </div>
                            ),
                            onClick: (event, rowData) => {
                              setModalType("distanceSlab");
                              setRowIndex(data.indexOf(rowData));
                              setOpen(true);
                            }
                          }),
                          {
                            icon: "add",
                            tooltip: t("add_carType"),
                            isFreeAction: true,
                            onClick: (event) => navigate("/cartypes/editcartype", { state: { pageNo: currentPage } })
                          },
                          {
                            icon: "edit",
                            tooltip: t("edit"),
                            onClick: (event, rowData) => {
                              navigate(`/cartypes/editcartype/${rowData.id}`, { state: { pageNo: currentPage } });
                            }
                          },

                        ].filter(Boolean)
                  }
                />
              </div>
            );
          })}
        </div>
      ) : (
        <BlankTable title={t('car_type_title')} 
        actions={isFleetAdmin ? [] : [
          {
            icon: "add",
            tooltip: t("add_carType"),
            isFreeAction: true,
            onClick: (event) => navigate("/cartypes/editcartype"),
          },
        ]}
        columns={columns}  data={[]} localization={localization(t)} options={TableStyle()}/>
      )}
    </ThemeProvider> 
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal && !isFleetAdmin}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6" style={{ fontFamily: FONT_FAMILY }} >
              {t("upload_car_image")}

              <input
                type="file"
                style={{ marginLeft: 10, fontFamily: FONT_FAMILY }}
                name={t("image")}
                onChange={(event) => {
                  setSelectedImage(event.target.files[0]);
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage && !loading ? (
              <Tooltip style={{ fontFamily: FONT_FAMILY }} title={t("cancel")}>
                <CancelIcon
                  onClick={() => setSelectedImage(null)}
                  style={{
                    fontSize: 30,
                    backgroundColor: colors.RED,
                    borderRadius: 50,
                    color: colors.WHITE,
                  }}
                />
              </Tooltip>
            ) : null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage ? (
              <img
                alt="not fount"
                width={"200px"}
                height={"200px"}
                src={URL.createObjectURL(selectedImage)}
                style={{ marginTop: 15, marginBottom: 20 }}
              />
            ) : (
              <img
                alt="not fount"
                width={"200px"}
                height={"200px"}
                src={imageData}
                style={{ marginTop: 10 }}
              />
            )}
            <br />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
          >
            {loading ? (
              <Grid
                container
                spacing={0}
                alignItems="center"
                justify="center"
                style={{ minHeight: "5vh" }}
              >
                <CircularProgress />
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
              >
                <Button
                  onClick={handleProfileModal}
                  variant="contained"
                  style={{ backgroundColor:colors.RED, fontFamily: FONT_FAMILY  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={handleSetProfileModal}
                  variant="contained"
                  style={{ marginLeft: 10 , backgroundColor:colors.GREEN, fontFamily: FONT_FAMILY  }}
                >
                  {t("save")}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        onClose={handleClose}
        open={open}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <div className={classes.paper}>
        <ThemeProvider theme={theme}>
          <MaterialTable
            title={
              modalType === "options"
                ? t("options")
                : modalType === "cancelSlab"
                ? t("cancelSlab")
                : modalType === "distanceSlab"
                ? t("distanceSlab")
                : t("parcel_types")
            }
            columns={
              modalType === "cancelSlab" 
                ? subcolumns2 
                : modalType === "distanceSlab" 
                ? subcolumns3 
                : subcolumns
            }
            data={
              data[rowIndex] && data[rowIndex][modalType]
                ? data[rowIndex][modalType]
                : []
            }
            options={{
              exportButton: true,
              actionsColumnIndex: -1,
              cellStyle: {
                border: `1px solid ${colors.TABLE_BORDER}`,
                textAlign: "center",
              },
              headerStyle: {
                position: "sticky",
                top: "0px",
                fontSize: "0.8em",
                fontWeight: "bold ",
                color: colors.BLACK,
                backgroundColor: SECONDORY_COLOR,
                textAlign: "center",
                border: `1px solid ${colors.TABLE_BORDER}`,
              },
            }}
            editable={
              (isFleetAdmin || !isFleetAdmin) ? {
                onRowAdd: (newData) =>
                  settings.AllowCriticalEditsAdmin
                    ? new Promise((resolve) => {
                        setTimeout(async() => {
                          resolve();
                          // Create a deep copy of the data array
                          let tblData = JSON.parse(JSON.stringify(data));
                          if (!tblData[rowIndex][modalType]) {
                            tblData[rowIndex][modalType] = [];
                          }
                          tblData[rowIndex][modalType].push(newData);
                          if(newData.description && (modalType !== "cancelSlab") && (modalType !== "distanceSlab")){
                            await convertLanguage(newData.description, auth?.profile?.lang?.langLocale ? auth.profile.lang.langLocale : null);
                          }
                          dispatch(editCarType(tblData[rowIndex]), "Update");
                          // Update the state to trigger re-render
                          setData(tblData);
                        }, 600);
                      })
                    : new Promise((resolve) => {
                        setTimeout(() => {
                          resolve();
                          alert(t("demo_mode"));
                        }, 600);
                       }),
                onRowUpdate: (newData, oldData) =>
                  settings.AllowCriticalEditsAdmin
                    ? new Promise((resolve) => {
                        setTimeout(async () => {
                          resolve();
                          if (newData !== oldData) {
                            // Create a deep copy of the data array
                            let tblData = JSON.parse(JSON.stringify(data));
                            tblData[rowIndex][modalType][oldData.tableData.id] =
                              newData;
                              if(oldData.description !== newData.description && (modalType !== "cancelSlab") && (modalType !== "distanceSlab")){
                                await convertLanguage(newData.description, auth?.profile?.lang?.langLocale ? auth.profile.lang.langLocale : null);
                              }
                            dispatch(editCarType(tblData[rowIndex]), "Update");
                            // Update the state to trigger re-render
                            setData(tblData);
                          }
                        }, 600);
                      })
                    : new Promise((resolve) => {
                        setTimeout(() => {
                          resolve();
                          alert(t("demo_mode"));
                        }, 600);
                       }),
                onRowDelete: (oldData) =>
                  settings.AllowCriticalEditsAdmin
                    ? new Promise((resolve) => {
                        setTimeout(() => {
                          resolve();
                          // Create a deep copy of the data array
                          let tblData = JSON.parse(JSON.stringify(data));
                          const index = tblData[rowIndex][modalType];
                          const neTtblData = index.filter(
                            (item) =>
                              item.amount !== oldData.amount &&
                              (modalType === "cancelSlab"
                                ? item.minsDelayed !== oldData.minsDelayed
                                : modalType === "distanceSlab"
                                ? (item.from_distance !== oldData.from_distance || item.to_distance !== oldData.to_distance)
                                : item.description !== oldData.description)
                          );
                          tblData[rowIndex][modalType] = neTtblData;
                          dispatch(editCarType(tblData[rowIndex]), "Update");
                          // Update the state to trigger re-render
                          setData(tblData);
                        }, 600);
                      })
                    : new Promise((resolve) => {
                        setTimeout(() => {
                          resolve();
                          alert(t("demo_mode"));
                        }, 600);
                       }),
              } : undefined}
          />
        </ThemeProvider>
        </div>
      </Modal>
      <Dialog open={duplicateDialog.open} onClose={() => setDuplicateDialog({ open: false, sourceZoneId: null })} maxWidth="sm" fullWidth>
        <DialogTitle>{t("duplicate_group") || "Duplicate Zone Group"}</DialogTitle>
        <DialogContent style={{ paddingTop: 20 }}>
          <Typography variant="body2" style={{ marginBottom: 15 }}>
            {t("select_zone_to_duplicate") || "Select a zone to duplicate this group to:"}
          </Typography>
          <FormControl fullWidth>
            <Select
              value={selectedDuplicateZone}
              onChange={(e) => setSelectedDuplicateZone(e.target.value)}
              displayEmpty
            >
              <MenuItem value="" disabled>
                {t("select_zone") || "Select a zone"}
              </MenuItem>
              {getAvailableZonesForDuplicate?.map((zone) => (
                <MenuItem key={zone.id} value={zone.id}>
                  {zone.zone_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography variant="caption" style={{ marginTop: 15, display: "block", color: "#666" }}>
            {t("duplicate_note") || "Note: Fleet admin field will be cleared in the duplicated car types. Only zones without existing car types are available."}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDuplicateDialog({ open: false, sourceZoneId: null })} style={{ backgroundColor: colors.RED }}>
            {t("cancel")}
          </Button>
          <Button 
            onClick={handleConfirmDuplicate} 
            variant="contained" 
            style={{ backgroundColor: colors.GREEN }}
            disabled={!selectedDuplicateZone || getAvailableZonesForDuplicate.length === 0}
          >
            {t("duplicate")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
